import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet, Col, Row, Button, Divider, Form } from '_zari/core'

import * as PlantillaService from 'services/plantillaCabeceraPie.service'

import * as FormGroups from './formGroups'

const portletBreadcrumbs = [{ name: 'Editar Plantillas' }]

const PlantillasPage = (history) => {
  const __zariContext = React.useContext(ZariContext)

  const [tipo, setTipo] = React.useState('')
  const [tipoDocumento, setTipoDocumento] = React.useState('')
  const [textoPlantilla, setTextoPlantilla] = React.useState(null)

  const infoPlantillaEncontrada = React.useRef(null)

  const changeTipo = React.useCallback(e => {
    setTipo(e.target.value)
    setTextoPlantilla(null)
    infoPlantillaEncontrada.current = null
  }, [])

  const changeTipoDocumento = React.useCallback(e => {
    setTipoDocumento(e.target.value)
    setTextoPlantilla(null)
    infoPlantillaEncontrada.current = null
  }, [])

  const clickEditar = React.useCallback(() => {
    setTextoPlantilla(null)
    infoPlantillaEncontrada.current = null

    if (!tipoDocumento) {
      __zariContext.snack('error', 'Seleccionar tipo documento.')
      return
    }

    if (!tipo) {
      __zariContext.snack('error', 'Seleccionar tipo.')
      return
    }

    PlantillaService.getPlantilla({
      tipo: tipo,
      tipoDocumento: tipoDocumento
    })
      .then(({ data }) => {
        if (data) {
          infoPlantillaEncontrada.current = data
          setTextoPlantilla(data.plantilla)
        } else {
          setTextoPlantilla('')
        }
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext, tipo, tipoDocumento])

  const clickCancelar = React.useCallback(() => {
    setTextoPlantilla(null)
    infoPlantillaEncontrada.current = null
  }, [])

  const clickGuardar = React.useCallback(() => {
    if (infoPlantillaEncontrada.current) {
      PlantillaService.actualizarPlantilla(infoPlantillaEncontrada.current._id, {
        plantilla: textoPlantilla
      })
        .then(() => {
          // setTextoPlantilla(null)
          // infoPlantillaEncontrada.current = null
          __zariContext.snack('success', 'Plantilla actualizada.')
          history.push(`/`)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    } else {
      PlantillaService.nuevaPlantilla({
        tipo: tipo,
        tipoDocumento: tipoDocumento,
        plantilla: textoPlantilla
      })
        .then(() => {
          // setTextoPlantilla(null)
          // infoPlantillaEncontrada.current = null
          __zariContext.snack('success', 'Plantilla actualizada.')
          history.push(`/`)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    }
  }, [__zariContext, tipo, tipoDocumento, textoPlantilla, history])

  return (
    <Portlet>
      <Portlet.Header title='EDITAR PLANTILLAS' breadcrumbs={portletBreadcrumbs} />
      <Portlet.Body>
        <Row>
          <Col xs={6} sm={5} md={4} xl={3}>
            <FormGroups.TipoDocumentoFormGroup
              value={tipoDocumento}
              onChange={changeTipoDocumento}
              disabled={textoPlantilla !== null}
            />
          </Col>
          <Col xs={6} sm={4} md={3} xl={2}>
            <FormGroups.TipoFormGroup value={tipo} onChange={changeTipo} disabled={textoPlantilla !== null} />
          </Col>
          <Col sm={2} xl={1}>
            <Button block disabled={textoPlantilla !== null} onClick={clickEditar}>
              Editar
            </Button>
          </Col>
        </Row>
        {textoPlantilla !== null && (
          <>
            <Divider />
            <Row className='mt-3'>
              <Col md={12}>
                <Form.Wysiwyg value={textoPlantilla} onChange={e => setTextoPlantilla(e.target.innerHTML)} />
              </Col>
            </Row>
            <Row className='mt-2'>
              <Col md={12} className='text-right'>
                <Button color='secondary' onClick={clickCancelar}>
                  Cancelar
                </Button>
                <Button onClick={clickGuardar}>Guardar</Button>
              </Col>
            </Row>
          </>
        )}
      </Portlet.Body>
    </Portlet>
  )
}

export default PlantillasPage
